import React, { createContext, useContext, useState, ReactNode } from "react";
import { SupportedLanguage } from "../types/translations.types";

interface ModalLanguageContextType {
 currentLanguage: SupportedLanguage;
 setCurrentLanguage: (language: SupportedLanguage) => void;
}

export const ModalLanguageContext = createContext<ModalLanguageContextType | undefined>(undefined);

export const ModalLanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
 const [currentLanguage, setCurrentLanguage] = useState<SupportedLanguage>("en");

 return (
  <ModalLanguageContext.Provider value={{ currentLanguage, setCurrentLanguage }}>
   {children}
  </ModalLanguageContext.Provider>
 );
};

export const useModalLanguage = (): ModalLanguageContextType => {
 const context = useContext(ModalLanguageContext);
 if (!context) {
  throw new Error("useModalLanguage must be used within a ModalLanguageProvider");
 }
 return context;
};

